import Api from '@/services/Api' // axois object created in api.js
import consola from 'consola'

export default { // export its register method
  getPlatformSpecialStatus ({ dateTime }: { dateTime: string }) {
    consola.info('[PlatformService getPlatformSpecialStatus] Sending request via GET method to server, waiting for server response ...')
    return Api().get('platform/status', { params: { dateTime: dateTime } })
  }
}
